<template>
  <div v-if="message" v-bind:class="cs">
    {{message}}
  </div>
</template>

<script>
export default {
  props: ['color','message'],
  setup(props){
    const cs = 'notification is-light ' + props.color;
    return {
      cs
    }
  }
}
</script>